'use strict';

const bonusProductsView = require('../bonus-products-view'),
    quantityBlock = require('./product/quantity-block'),
    storeMissingStockWarning = require('./checkout/storeMissingStockWarning'),
    taxFreeThresholdPassedWarning = require('./checkout/taxFreeThresholdPassedWarning'),
    cartStoreInventory = require('../storeinventory/cart'),
    page = require('../page'),
    giftwrap = require('../giftwrap'),
    productTile = require('../product-tile'),
    toaster = require('../toaster'),
    ajax = require('../modules/ajax'),
    validator = require('../validator'),
    isMobile = require('../modules/util/isMobile'),
    shipping = require('./checkout/shipping'),
    gtm = require('../modules/google').tagManager,
    isInViewport = require('../modules/helpers/isInViewport'),
    isSmallView = require('../modules/helpers/isSmallView'),
    dialog = require('../dialog'),
    pgCartUtils = require('./personalisedgifting/pgCartUtils'),
    ritualsFormHelper = require('../rituals-form-helper'),
    places = require('../modules/google').places,
    getCountryFromLocaleCookie = require('../modules/util/getCountryFromLocaleCookie'),
    isMobileOrTabletWidth = require('../modules/util/isMobileOrTabletWidth'),
    damHelper = require('../dam/dam-helper'),
    cartPostalCode = require('./cart/cartPostalCode');

/* To prevent multiple submissions of the form when removing a product from the cart */
let removeItemEvent = false;

/**
* @private
* @function
* @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
*/
function initializeEvents() {
    //initialize quantity buttons on cart page
    quantityBlock.init();

    $(document).on('click', '.js-edit-details', function (e) {
        e.preventDefault();
        $(this).toggleClass('open');
        $(e.target).closest('.js-cart-product-user-controls').find('.js-cart-product-variation-edit').toggleClass('open');

        if ($('.js-dangerousgoods-error').length) {
            $(e.target).closest('.js-cart-product-user-controls').siblings('.js-dangerousgoods-error').toggleClass('open');
        }
    });

    $(document).on('click', '.bonus-item-actions a.js-change-bonus-product', function (e) {
        e.preventDefault();

        const viewParameters = {
            url: $(this).data('href'),
            giftChange: true,
            response: null,
            isAddedPopup: $(this).data('showadded'),
            selectedID: String($(this).data('currently-selected'))
        };

        if ($(this).data('change-tiered-promotion')) {
            viewParameters.tieredDiscountId = $(this).closest('.js-bonus-product').find('.js-tiered-gwp-selection').data('discount-id');
        }

        const giftLabelDiv = e.currentTarget.parentNode.parentNode.querySelector('.gift-label');
        const giftName = giftLabelDiv ? giftLabelDiv.textContent : null;

        gtm.pushGwpEvent('choose a different gift', giftName);
        bonusProductsView.show(viewParameters);
    });

    $(document).on('click', '.js-gwp-cart-banner-cta', function() {
        gtm.pushGwpEvent('continue shopping');
    });

    //listener to reset removeItemEvent when action is triggered on popup
    $(document).on('resetPopupDialog', function () {
        removeItemEvent = false;
    });

    $(document).on('keypress', '.js-coupon-input-field input', function (e) {
        if (e.which == 13) {
            e.preventDefault();

            $('.js-coupon-btn button').trigger('click');
        }
    });

    $(document).on('click', '.js-coupon-btn', addCoupon);

    $(document).on('submit', '#postalcode-form', searchByPostalCode);

    //TODO:
    //This is a temporary fix (no better solution for now) for bug [DL-10166].
    disablePostalCodeInputFieldValidationForMouseWithinButtonBorders();

    validator.init();

    // override enter key for coupon code entry
    $(document).on('keydown', 'form input[name$="_couponCode"]', function (e) {
        if (e.which === 13 && $(this).val().length === 0) {
            return false;
        }
    });

    $(document).on('click', 'button[name$="deleteProduct"]', function (e) {
        e.preventDefault();
        if (!removeItemEvent) {
            removeItemEvent = true;

            // initialize quantity block to get the delta quantity value
            quantityBlock.buildObj($($(this)
                .parents('.js-cart-row')
                .find('.js-quantity')));

            // post the event
            quantityBlock.removeFullQuantity();
        }
    });

    $(document).on('click', 'button[name$="deleteProductSet"]', function () {
        const pid = $(this).data('master-product-id');
        if (pid) {
            gtm.updateQuantity('cart', pid.toString(), null, null, null, 1, 'remove_from_cart');
        }
    });

    //DL-3889 Switch between tiered GWPs
    $(document).on('change', '.js-tiered-gwp-selection', function () {
        const uuid = $(this).data('discount-id');

        if (!uuid){
            return;
        }

        $.ajax({
            type: 'POST',
            url: Urls.selectTieredGWP,
            data: {
                'bonusDiscountLineItemUUID': uuid
            },
            success: function(){
                //Refresh the cart to update the view
                page.refresh();
            }
        });

        const giftLabelDiv = $(this).closest('.gift-label');
        const giftName = giftLabelDiv ? giftLabelDiv.textContent : null;
        gtm.pushGwpEvent('choose one of the gifts', giftName);
    });

     //POC for changing product options in the cart TODO:
     $(document).on('click', '.js-option-change-btn', function(evt) {
        evt.preventDefault();
        const productId = $(this).data('product-id');
        const productLineUUID = $(this).data('line-item-uuid');
        const cartRow = $(this).closest('.js-cart-row');
        const optionValues = cartRow.find('.js-options-dropdown');

        const selectedOptions = {};
        optionValues.each(function(idx, elm){
            const $elm = $(elm);
            selectedOptions[$elm.data('option-id')] = $elm.val();
        });

        $.ajax({
            type: 'POST',
            url: Urls.POCCartChangeOptions,
            data: {
                productId: productId,
                productLineUUID: productLineUUID,
                options: JSON.stringify(selectedOptions)
            },
            success: function(){
                //Refresh the cart to update the view. Also takes care of recalculating the cart (happens on refresh)
                page.refresh();
            }
        });
    });

    // if there is a shipping exclusion open toaster
    if ($('.js-shipment-exclusion-toaster').length > 0 && isMobile()){
        toaster.open({
            target: $('.js-shipment-exclusion-toaster')
        });
    }


    // if there is a product quantity limit open toaster
    if ($('.js-product-quantity-limit-toaster').length > 0){
        toaster.open({
            target: $('.js-product-quantity-limit-toaster')
        });
    }

    $(document).on('click', '.js-delivery-postal-code-edit', function () {
        const $this = $(this);
        const $siblings = $this.parents('.js-delivery-postal-code').find('.js-delivery-postal-code-form');
        $this.parent().hide();
        $siblings.show();
        $('.js-delivery-usp-heading').removeClass('hide');
    });

    $(document).on('change', '.js-option-radio', function() {
        const page = 'cart_page';
        const $this = $(this);
        const defaultOption = $this.data('default-option');
        const shippingOptionId = $this.data('shipping-option-id');
        const shippingService = $this.data('shipping-service');
        const pickupPointCode = $this.data('service-point-code');

        giftwrap.getGiftwrapDataForSelectedShippingOption(defaultOption, page, null, function() {
            shipping.updateShippingInformation(shippingOptionId, shippingService, pickupPointCode, null, function(response) {
                updateOrderTotals(response.selectedShippingOption);
            }, defaultOption, null);
        });
    });

    $(document).on('change', '.js-service-point-postnummer-input', function(){
        const dHLPostNummer = $(this).val();
        setHiddenDHLPostNummer(dHLPostNummer);
    });

    $(document).on('click', '.js-cart-submit-btn', function(e){
        const $this = $(this);
        const $form = $this.closest('form');

        if (!isFakeSelectionValid()) {
            return false;
        }

        $('.js-service-point-postnummer-input-error').addClass('hide');
        const accountNumberInput = $('.js-service-point-postnummer-input');
        //if paazl distributor is DHL germany, service points are selected and accountnumber field exists, validate input first
        if ($('.js-pickup-option-radio').is(':checked') && accountNumberInput.length) {
            e.preventDefault();

            $.ajax({
                type: 'GET',
                url: Urls.checkoutCheckAccountServiceNumberForPaazl,
                data: {
                    accountServiceNumber: accountNumberInput.val()
                },
                success: function (data) {
                    if (data.valid) {
                        const deliveryMethod = getDeliveryMethod();
                        gtm.pushDeliveryMethod(deliveryMethod);

                        $form.find('.js-hidden-cart-submit-btn').removeAttr('disabled');
                        $form.submit();

                        $this.addClass('button-loading');
                        $this.find('.js-spinner-general').addClass('spinner-visible');
                    } else {
                        $('.js-service-point-postnummer-input-error').removeClass('hide');
                    }
                }
            });
        } else {
            const deliveryMethod = getDeliveryMethod();
            gtm.pushDeliveryMethod(deliveryMethod);

            $this.addClass('button-loading');
            $this.find('.js-spinner-general').addClass('spinner-visible');
        }
    });

    if (document.referrer && !document.referrer.includes('checkout') && !document.referrer.includes('cart')) {
        sessionStorage.setItem('previousURL', document.referrer);
    }
    $(document).on('click', '.js-cart-back', function() {
        const lastPage = sessionStorage.getItem('previousURL');
        if (lastPage) {
            window.location.replace(lastPage);
            return;
        }
        window.history.back();
    });

    shipping.initPickupEvents();
    shipping.initUpdatingShippingInformation(updateOrderTotals);


    $(window).on('resize', function () {
        redesignAdjustment();
        bundlePriceAdjustment();
    });
}

function getDeliveryMethod() {
    const $shippingOption = $('.js-option-radio:checked');
    return $shippingOption.length ? $shippingOption.data('delivery-method-type') : 'unknown';
}

function scrollToErrorMessage(element) {
    if (!isInViewport(element)) {
        let top = element.offset().top;

        const header = $('.js-personalised-gifting-header');
        top = top - (header.height() || 0);

        $('html, body').scrollTop(top);
    }
}

function isFakeSelectionValid() {
    const $fakeSelected = $('[data-fake-errors]:checked');
    const $shippingOptionsError = $('#shippingOptionsError');

    if (!$fakeSelected.length) {
        $shippingOptionsError.text('').addClass('hide');
        return true;
    }

    const postalCodeError = $('span[id^="dwfrm_shippingpostalcode_postal-error"]').text();

    if (postalCodeError !== '') {
        $shippingOptionsError.text('').addClass('hide');
        return false;
    }

    const postalCode = $('input[id^="dwfrm_shippingpostalcode_postal"]').val();
    let errors = $fakeSelected.data('fake-errors');

    if (errors instanceof String) {
        errors = JSON.parse(errors);
    }
    $shippingOptionsError.text(postalCode ? errors.confirmation : errors.missing);
    scrollToErrorMessage($fakeSelected);
    $shippingOptionsError.removeClass('hide');
    return false;
}

function disableNotChosenGifts(){
        $('.js-tiered-gwp-selection:radio').each(function(){
            if ($(this).is(':checked')) {
                $(this).closest('.tiered-gwp-choose').addClass('crm-gift-checked');
                }
            });
            $('.gwp-select-box').click(function () {
            $('.js-tiered-gwp-selection:radio').each(function(){
                $(this).closest('.tiered-gwp-choose').removeClass('crm-gift-checked');
            });
            $(this).closest('.tiered-gwp-choose').addClass('crm-gift-checked');

    });
}

//TODO:
//This is a temporary fix (no better solution for now) for bug [DL-10166].
function disablePostalCodeInputFieldValidationForMouseWithinButtonBorders() {
    $(document).on('mouseenter', '.js-search-by-postalcode', function(){
        $('input[id^="dwfrm_shippingpostalcode_postal"]').data('prevent-automatic-validation', true);
    });
    $(document).on('mouseleave', '.js-search-by-postalcode', function(){
        $('input[id^="dwfrm_shippingpostalcode_postal"]').removeData('prevent-automatic-validation');
    });
}

function updateOrderTotals(selectedShippingOption) {
    $('.js-order-totals .js-order-value').text(selectedShippingOption.totalPrice);
    $('.js-order-totals .js-order-subtotal-value').text(selectedShippingOption.subtotalPrice);
    $('.js-checkout-sticky-bar .js-sticky-price-container .order-total-amount').text(selectedShippingOption.shippingPrice);

    if (selectedShippingOption.shippingPrice) {
        $('.js-shipping-price').text(selectedShippingOption.shippingPrice);
    }

    if (selectedShippingOption) {
        $('.js-totals-selected-shipping-option').text(selectedShippingOption.resource);
        $('.js-search-by-postalcode-title').text(selectedShippingOption.postalCodeButtonTitle);
    }

    const errorResults = handlePostalErrors(selectedShippingOption.exclusionResult);

    const $cartSubmitElement = $('.js-cart-action-checkout button');

    if (errorResults.enableCheckout) {
        $cartSubmitElement.removeClass('btn--disabled').removeAttr('disabled');
        return;
    }

    $cartSubmitElement.addClass('btn--disabled').attr('disabled', true);
}

function slideDownCouponBlock(){
    $('.js-cart-coupon-code').slideDown(0, {
        start: function () {
            $('.js-cart-coupon-code').css({
                display: 'flex'
            });
        }
    });
}

function applyCoupon() {
    const $form = $('.js-coupon-form');

    const options = {
        url: $form.attr('action'),
        data: $form.serialize() + '&dwfrm_cart_addCoupon=addCoupon', // triggered action
        type: 'POST',
        success: function(result) {
            const hasError = checkCouponResponseForErrors(result);

            if (!hasError && cartHasCouponExcludedAndRegularProducts(result)) {
                showCouponPartialyAppliedPopup(result);
                return;
            }

            updateAfterCouponChange(result);

            if (hasError) {
                $('.js-cart-coupon-trigger-btn').hide();
                slideDownCouponBlock();
                $('.js-cart-addcoupon-error-message').next().find('input').addClass('error-state');
                $('.js-coupon-btn').addClass('error-position');
            }
        },
        error: function() {
            $('.js-cart-coupon-trigger-btn').hide();
            slideDownCouponBlock();
            $('.js-cart-addcoupon-error-message').next().find('input').addClass('error-state');
            $('.js-coupon-btn').addClass('error-position');
        },
        complete: function() {
            $('#add-coupon').removeClass('button-loading');
            $('.js-coupon-code-spinner').removeClass('spinner-visible');
        },
    };

    $.ajax(options);
}

function updateAfterCouponChange(couponAppliedResult) {
    const $result = $(couponAppliedResult);
    const itemsHtml = $result.find('#cart-items-form').html();
    const subtotalsHtml = $result.find('.js-order-totals');
    const giftsInMinicartHTML = $result.find('.js-gwp-minicart-wrapper');
    $('#cart-items-form').html(itemsHtml);
    damHelper.updateImages('#cart-items-form');
    $('.js-order-totals').html(subtotalsHtml);
    $('.js-gwp-minicart-wrapper').html(giftsInMinicartHTML);
    damHelper.updateImages('.js-gwp-minicart-wrapper');

    // get new checkout sticky bar
    ajax.load({
        url: Urls.getStickyCheckoutBar,
        target: $('.js-checkout-sticky-bar'),
        data: {
            shipmentExcludedProductIDs: $('input[name="shipmentExcludedProductIDs"]').val()
        },
        replaceTarget: true
    });

    redesignAdjustment();
    bundlePriceAdjustment();
}

function deleteCoupon() {
    const $form = $('.js-coupon-form');
    const lastCouponIndex = $('.js-cart-row-coupon').length;
    const options = {
        url: $form.attr('action'),
        data: $form.serialize() + `&dwfrm_cart_coupons_i${lastCouponIndex}_deleteCoupon=deleteCoupon`,
        type: 'POST',
        success: function(result) {
            updateAfterCouponChange(result);
        }
    };

    $.ajax(options);
}

function createBonusWarningDialogForAppliedCoupon(removedBonusProductImagesHtml) {
    let removeProducts = false;

    $('.js-free-product-removal').find('.js-free-product-removal-images').html(removedBonusProductImagesHtml);
    $('.js-free-product-removal').find('.js-remove-popup-text').text(Resources.REMOVE_POPUP_COUPON);
    $('#add-coupon').addClass('button-loading');
    $('.js-coupon-code-spinner').addClass('spinner-visible');

    if (isMobileOrTabletWidth()) {
        toaster.def.$toastContent.html($('.js-free-product-removal').html());
        toaster.open({
            open: function() {
                $('.js-modal-overlay').show();

                $(document).off('click.popup', '.js-remove-gwp-product').on('click.popup', '.js-remove-gwp-product', function(){
                   removeProducts = true;
                   toaster.closeToasters();
                });
                $(document).off('click.popup', '.js-keep-gwp-product').on('click.popup', '.js-keep-gwp-product', function(){
                    removeProducts = false;
                    toaster.closeToasters();
                });

            },
            close: function () {
                if (removeProducts) {
                    applyCoupon();

                    return;
                }
                $('#add-coupon').removeClass('button-loading');
                $('.js-coupon-code-spinner').removeClass('spinner-visible');
            }
        });
        return;
    }
    dialog.open({
        html: $('.js-free-product-removal').html(),
        target: $('.js-bonus-product-dialog-wrapper'),
        options: {
            width: 600,
            dialogClass: 'bonus-dialog-content gwp-dialog',
            open: function() {
                $('.js-modal-overlay').show();

                $(document).off('click.popup', '.js-modal-overlay').on('click.popup', '.js-modal-overlay', function(){
                    dialog.close();
                });

                $(document).off('click.popup', '.js-remove-gwp-product').on('click.popup', '.js-remove-gwp-product', function(){
                    removeProducts = true;
                    dialog.close();
                });
                $(document).off('click.popup', '.js-keep-gwp-product').on('click.popup', '.js-keep-gwp-product', function(){
                    removeProducts = false;
                    dialog.close();
                });

            },
            close: function () {
                dialog.close();
                $('.js-modal-overlay').hide();

                if (removeProducts) {
                    applyCoupon();
                    return;
                }

                $('#add-coupon').removeClass('button-loading');
                $('.js-coupon-code-spinner').removeClass('spinner-visible');
            }
        }
    });
}

function showPPPopUp (popUpWrapper, btnAddToCart, quantity) {
    const quantityString = quantity ? (quantity + 1).toString() : '1';
    let changePPProduct = false;

    popUpWrapper.find($('.js-quantity-value')).text(quantityString);

    if (isMobileOrTabletWidth()) {
        toaster.def.$toastContent.html(popUpWrapper.html());
        toaster.open({
            open: function() {
                $('.js-modal-overlay').show();
                $('.js-generic-toaster').addClass('personal-promotion-content');

                $(document).off('click.popup', '.js-change-pp-product').on('click.popup', '.js-change-pp-product', function(){
                    changePPProduct = true;
                    toaster.closeToasters();
                });
                $(document).off('click.popup', '.js-keep-pp-product').on('click.popup', '.js-keep-pp-product', function(){
                    changePPProduct = false;
                    toaster.closeToasters();
                });
            },
            close: function () {
                $('.js-generic-toaster').removeClass('personal-promotion-content');

                if (changePPProduct) {
                    changePPProduct = false;
                    btnAddToCart.click();
                }
            }
        });
    } else {
    dialog.open({
        html: popUpWrapper.html(),
        target: $('.js-bonus-product-dialog-wrapper'),
        options: {
            width: 650,
            dialogClass: 'bonus-dialog-content gwp-dialog personal-promotion-content',
            open: function() {
                $('.js-modal-overlay').show();

                $(document).off('click.popup', '.js-modal-overlay').on('click.popup', '.js-modal-overlay', function(){
                    dialog.close();
                });

                $(document).off('click.popup', '.js-change-pp-product').on('click.popup', '.js-change-pp-product', function(){
                    changePPProduct = true;
                    dialog.close();
                });
                $(document).off('click.popup', '.js-keep-pp-product').on('click.popup', '.js-keep-pp-product', function(){
                    changePPProduct = false;
                    dialog.close();
                });

            },
            close: function () {
                dialog.close();
                $('.js-modal-overlay').hide();

                if (changePPProduct) {
                    btnAddToCart.click();
                }
            }
        }
    });
}
}

function showCouponPartialyAppliedPopup(couponAppliedResult) {
    window.eventBus.$on('couponApplyConfirmed', updateAfterCouponChange);
    window.eventBus.$on('couponApplyCanceled', deleteCoupon);
    window.eventBus.$emit('shouldOpenModal', {
        resources: {
            heading: Resources.COUPON_PARTIALLY_APPLIED_POPUP_HEADING ,
        },
        paragraphs: [
            {
                text: Resources.COUPON_PARTIALLY_APPLIED_POPUP_TEXT
            }
        ],
        ctaHolder: {},
        buttons: [
            {
                type: 'btn',
                label: Resources.COUPON_PARTIALLY_APPLIED_POPUP_CONFIRMED,
                eventName: 'couponApplyConfirmed',
                data: couponAppliedResult,
                shouldCloseModal: true
            }, {
                type: 'btn btn--secondary',
                label: Resources.COUPON_PARTIALLY_APPLIED_POPUP_CANCEL,
                eventName: 'couponApplyCanceled',
                shouldCloseModal: true
            }
        ],
        closeElement: {
            eventName: 'couponApplyCanceled',
            shouldCloseModal: true
        },
        modalLarge: true,
        centerOnMobile: true,
        customClass: 'modal-couponcode'
    });
}

function cartHasCouponExcludedAndRegularProducts(cartHtml) {
    return $(cartHtml).find('.js-has-coupon-excluded-and-regular-products').text() === 'true';
}

function addCoupon(e) {
    e.preventDefault();
    const $form = $('.js-coupon-form');

    $('#add-coupon').addClass('button-loading');
    $('.js-coupon-code-spinner').addClass('spinner-visible');

    $.ajax({
        url: Urls.checkRemoveBonusProductsWithCoupon,
        data: {
            couponCode: $form.find('input[name$=_couponCode]').val()
        }
    // eslint-disable-next-line no-use-before-define
    }).fail(function (jqXHR, status, err) {
        console.error('Failure checking for removed bonus products: ', err);
    })
    .done(function (removedProductImages) {
        if (removedProductImages) {
            //Get the dynamic header and description from the rendered template and place them in the correct place in the popup
            const originHeaderDiv = $(removedProductImages).find('#js-remove-gwp-popup-header');
            const targetHeaderDiv = $('.js-custom-popup-header');
            $(targetHeaderDiv).html($(originHeaderDiv).html());

            createBonusWarningDialogForAppliedCoupon(removedProductImages);
        } else {
            applyCoupon();
        }
    });
}

function searchByPostalCode(e) {
    e.preventDefault();

    const $form = $(this);
    const $postalCodeElement = $('#dwfrm_shippingpostalcode_postal', $form);

    if ($postalCodeElement.val() === $form.data('current-postal-code')) {
        return;
    }

    if (!$form.valid()) {
        return;
    }

    const $buttonElement = $('.js-search-by-postalcode', $form);
    const $orderTotals = $form.parents('.js-order-totals');
    const $cartSubmitElement = $('.js-cart-action-checkout button');
    const $defaultSelected = $('.js-option-radio:checked', $orderTotals);
    const selectedDefaultRadio = $defaultSelected.length ? '&selectedDefaultRadio=' + $defaultSelected.data('default-option') : '';
    const pickupInStoreEnabled = $('.js-enabled-geolocation', $orderTotals).length;
    const selectedShippingType = $defaultSelected.data('default-option');

    $('.js-cart-row .js-dangerousgoods-error p').text(''); //Remove any product-specific error messages
    $('.js-postal-code-spinner', $buttonElement).addClass('spinner-visible');

    $buttonElement.addClass('button-loading');
    $cartSubmitElement.addClass('btn--disabled').attr('disabled', true);

    const ajaxOptions = {
        url: $form.attr('action'),
        data: $form.serialize() + '&dwfrm_cart_searchByPostalCode=searchByPostalCode' + selectedDefaultRadio,
        type: 'POST',
        success: function(result) {
            $orderTotals.html(result);
            ritualsFormHelper.initializeDataMask('.js-order-totals');
            validator.init();
            const newSelectedShippingType = $('.js-option-radio:checked', $orderTotals).data('default-option');
            if (selectedShippingType != newSelectedShippingType) {
                giftwrap.getGiftwrapDataForSelectedShippingOption(newSelectedShippingType, 'cart');
            }
            const errorResults = handleHTMLErrors();

            if (errorResults.enableCheckout) {
                $cartSubmitElement.removeClass('btn--disabled').removeAttr('disabled');
            }
            //handleExclusionResults();
        },
        error: function(xhr) {
            if (xhr.status === 400) { //Postal code error will result in a 400 status
                const response = xhr.responseJSON;
                handlePostalErrors(response);
            }
        },
        complete: function() {
            $('.js-postal-code-spinner').removeClass('spinner-visible');
            $('.js-search-by-postalcode').removeClass('button-loading');

            if ($('.js-shipping-home-delivery-select .js-custom-select').parent('.selectric-hide-select').length < 1) {
                $('.js-shipping-home-delivery-select .js-custom-select').selectric();
            }
        }
    };

    if (pickupInStoreEnabled) {
        places.getLatLongFromPostalCode($postalCodeElement.val(), getCountryFromLocaleCookie(), function (latitude, longitude) {
            ajaxOptions.data += '&latitude=' + latitude + '&longitude=' + longitude;
            $.ajax(ajaxOptions);
        });
        return;
    }

    $.ajax(ajaxOptions);
}

function showShippingExclusionToasterMessage(shipmentExclusionAssetID) {
    if (shipmentExclusionAssetID) {
        if ($('.js-shipment-exclusion-toaster').length > 0) {
            toaster.open({
                target: $('.js-shipment-exclusion-toaster')
            });
        } else {
            $.ajax({
                url: Urls.getShippingExclusionToastMessage,
                data: {shipmentExclusionAssetID},
                success: function(result) {
                    $('.js-shipment-exlusion-toast-message-container').html(result);
                    toaster.initDef();
                    toaster.open({
                        target: $('.js-shipment-exclusion-toaster')
                    });
                }
            });
        }
    }
}

function handlePostalErrors(errors) {
    const retVal = {
        enableCheckout: errors && errors.EnableCheckout === false ? false : true
    };

    $('#shippingOptionsError').text('').addClass('hide');
    $('.js-cart-row .js-dangerousgoods-error p').text('');
    $('#dwfrm_shippingpostalcode_postal-error').remove();

    const formValidator = $('#postalcode-form').validate();
    formValidator.resetForm();
    if (!errors || !errors.PostalCodeError) {
        return retVal;
    }

    $('.js-delivery-usp-heading.hide').removeClass('hide');
    $('.js-delivery-postal-code-form.hide').removeClass('hide');
    $('.js-postal-code-edit-wrapper:not(.hide)').addClass('hide');
    const $postalCode = $('#dwfrm_shippingpostalcode_postal');

    if ($postalCode.val()) {
        const errorObj = {};
        errorObj[$postalCode.attr('name')] = errors.PostalCodeError;
        formValidator.showErrors(errorObj);
    }

    if (isMobile()) {
        showShippingExclusionToasterMessage(errors.shipmentExclusionAssetID);
    }

    if (errors.ExcludedProductIDs) {
        //TODO
        for (const idx in errors.ExcludedProductIDs) {
            const productId = errors.ExcludedProductIDs[idx];

            const $excludedProductsMessage = $('.js-cart-row[data-product-id=' + productId + '] .js-dangerousgoods-error');
            $excludedProductsMessage.find('p').text(errors.ExcludedProductsMessage);
            $excludedProductsMessage.show();
        }
    }

    return retVal;
}

function handleHTMLErrors() {
    const $errorTextElement = $('#postalError');
    let errors = {};

    if ($errorTextElement.length) {
        errors = JSON.parse($errorTextElement.val());
        $errorTextElement.remove();
    }

    return handlePostalErrors(errors);
}

function checkCouponResponseForErrors(result) {
    const coupons = $(result).find('.cartcoupon');
    const errorMessage = $(result).find('.js-cart-addcoupon-error-message');
    if (coupons.length > 0 && errorMessage.length == 0) {
        const lastCoupon = coupons.last().find('.value')[0].innerText.trim();
        gtm.pushAddCouponValid(lastCoupon);
    }

    return errorMessage.length > 0;
}

function redesignAdjustment() {
    const cartRow = $('.js-cart-row');

    if (cartRow.length) {
        cartRow.each(function () {
            const $this = $(this);
            const cartPrice = $this.find('.js-cart-product-price');
            const cartDescription = $this.find('.js-cart-product-desc').find('.name');
            const quantityButtons = $this.find('.js-item-user-buttons');
            const pgCartWrapper = $('.js-pg-cart-page-wrapper');

            if (cartDescription.length) {
                if (!isSmallView()) {
                    cartPrice.css('padding-top', cartDescription.outerHeight());
                    quantityButtons.css('padding-top', cartDescription.outerHeight() + 2);
                } else if (isSmallView() && pgCartWrapper.length) {
                    cartPrice.css('padding-top', cartDescription.outerHeight() - 1);
                }

                if (pgCartWrapper.length) {
                    cartPrice.addClass('has-padding');
                }
            }
        });
    }
}

function couponCodeToggle() {
    const showCouponField = '.js-cart-coupon-trigger-btn';
    $(document).on('click', showCouponField, function () {
        $(showCouponField).hide();
        slideDownCouponBlock();
    });
}

function bundleToggle() {
    const $bundleWrapper = '.js-bundle-container';

    $(document).on('click', '.js-open-bundle', function () {
        if (!$(this).hasClass('open')) {
            $(this).addClass('open');
            $(this).closest('.js-cart-row').next().find($bundleWrapper).stop().show().removeAttr('aria-hidden');

            bundlePriceAdjustment();
        } else {
            $(this).removeClass('open');
            $(this).closest('.js-cart-row').next().find($bundleWrapper).stop().hide().attr('aria-hidden', 'true');
        }
    });
}

function bundlePriceAdjustment() {
    const bundleWrapper = $('.bundle-wrapper');

    if (bundleWrapper.length) {
        bundleWrapper.each(function() {
            const bundlePrice = $(this).find('.js-rowbundle').find('.js-bundle-price');
            const bundleDescription = $(this).find('.js-bundle-product__desc').find('.name');

            if (isSmallView()) {
                bundlePrice.css('padding-top', bundleDescription.outerHeight() + 10);
            } else {
                bundlePrice.css('padding-top', bundleDescription.outerHeight() - 2);
            }
        });
    }
}

function handlePPPopUp () {
    $(document).on('click', '.js-check-promo', function (e) {
        e.preventDefault();

        const productId = e.target.getAttribute('data-product-id');

        $.ajax({
            url: Urls.checkIfPPAlreadyApplied,
            data: {
                productId: productId
            }
        // eslint-disable-next-line no-use-before-define
        }).fail(function (jqXHR, status, err) {
            console.error('Failure checking for existing Personalized Promotion in the Cart ', err);
        }).done(function (response) {
            const btnAddToCart = e.target.closest('.promotion-add-to-cart').querySelector('.js-add-to-cart');

            if (response.addedPPToCart) {
                const popUpWrapper = $('.js-change-pp-product.product-pop-up-' + productId + '');

                showPPPopUp(popUpWrapper, btnAddToCart, response.quantity);
            } else {
                btnAddToCart.click();
            }
        });
    });
}

function setHiddenDHLPostNummer(dHLPostNummer) {
    const hiddenDHLPostNummer = $('input.js-dhl-post-nummer');
    hiddenDHLPostNummer.val(dHLPostNummer);
}

function currentCartAnalyticsB2B() {
    const purchaseDataElement = $('.js-cart-open-event');
    pushDataLayerEventCart(purchaseDataElement);
}

const pushDataLayerEventCart = function(element){
    if (element.length == 0) {
        return;
    }

    const analyticsData = $(element[0].attributes['data-analytics']);

    if (!analyticsData) {
        return;
    }
    gtm.pushDataLayerEvent(JSON.parse(analyticsData[0].value));
};

exports.init = function() {
    storeMissingStockWarning.createDialog();
    taxFreeThresholdPassedWarning.createDialog();
    shipping.initGWPChoosingPopup();
    ritualsFormHelper.initializeDataMask();
    initializeEvents();
    pgCartUtils.init();
    currentCartAnalyticsB2B();
    // init product tile for recommendations block
    productTile.init();
    disableNotChosenGifts();
    redesignAdjustment();
    bundleToggle();
    bundlePriceAdjustment();
    couponCodeToggle();
    handlePPPopUp();

    giftwrap.init();

    // init toaster messages events
    toaster.init();
    cartPostalCode.init();

    if (SitePreferences.STORE_PICKUP) {
        cartStoreInventory.init();
    }
};
